import { render, staticRenderFns } from "./Handle.vue?vue&type=template&id=23c3fe54&scoped=true"
import script from "./Handle.vue?vue&type=script&lang=js"
export * from "./Handle.vue?vue&type=script&lang=js"
import style0 from "./Handle.vue?vue&type=style&index=0&id=23c3fe54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c3fe54",
  null
  
)

export default component.exports